module.exports = __webpack_public_path__ + "img/mezclas_para_construccion.2a6bae50.png";